export const enum TokenAccessErrorReason {
	BusinessLogin = "business-login",
	MissingIdentity = "missing-identity",
	Api = "api",
}
